import { Action } from '@ngrx/store';
import { MeteringType } from '@enums';
import { Widget, WidgetSettings } from '@model';
import { WidgetLoaderConfiguration } from '../../../models/widget-loader-configuration';

export enum WidgetActionTypes {
  WidgetsSetAsLoading = '[Widget] Set as loading',
  WidgetDataLoad = '[Widget] Load data',
  WidgetDataLoadSuccess = '[Widget] Load data success',
  WidgetDataLoadFail = '[Widget] Load data fail',

  WidgetSettingUpdate = '[Setting] Widget Setting Update',
  WidgetSettingUpdateSuccess = '[Setting] Widget Setting Update success',
  WidgetSettingUpdateFail = '[Setting] Widget Setting Update fail',

  AvailableWidgetsLoad = '[Widget] Load avaliable widgets',
  AvailableWidgetsLoadSuccess = '[Widget] Load avaliable widgets success',
  AvailableWidgetsLoadFail = '[Widget] Load avaliable widgets fail'
}

export class WidgetsSetAsLoading implements Action {
  readonly type = WidgetActionTypes.WidgetsSetAsLoading;
  constructor(public payload: { meteringType: MeteringType; widgetNames: string[] }) {}
}

export class WidgetDataLoad implements Action {
  readonly type = WidgetActionTypes.WidgetDataLoad;
  constructor(public payload: WidgetLoaderConfiguration) {}
}

export class WidgetDataLoadSuccess implements Action {
  readonly type = WidgetActionTypes.WidgetDataLoadSuccess;
  constructor(public payload: { data: Widget[]; meteringType: MeteringType }) {}
}

export class WidgetDataLoadFail implements Action {
  readonly type = WidgetActionTypes.WidgetDataLoadFail;
  constructor(public payload: { error: any; widgetLoadConfig: WidgetLoaderConfiguration }) {}
}

export class AvailableWidgetsLoad implements Action {
  readonly type = WidgetActionTypes.AvailableWidgetsLoad;
  constructor() {}
}

export class AvailableWidgetsLoadSuccess implements Action {
  readonly type = WidgetActionTypes.AvailableWidgetsLoadSuccess;
  constructor(public payload: Widget[]) {}
}

export class AvailableWidgetsLoadFail implements Action {
  readonly type = WidgetActionTypes.AvailableWidgetsLoadSuccess;
  constructor(public payload: any) {}
}

export class WidgetSettingUpdate implements Action {
  readonly type = WidgetActionTypes.WidgetSettingUpdate;
  constructor(public payload: { widgets: Widget[]; meteringType: MeteringType }) {}
}

export class WidgetSettingUpdateSuccess implements Action {
  readonly type = WidgetActionTypes.WidgetSettingUpdateSuccess;
  constructor(public payload: WidgetSettings) {}
}

export class WidgetSettingUpdateFail implements Action {
  readonly type = WidgetActionTypes.WidgetSettingUpdateFail;
  constructor(public payload: any) {}
}

export type WidgetActions =
  | WidgetsSetAsLoading
  | WidgetDataLoad
  | WidgetDataLoadSuccess
  | WidgetDataLoadFail
  | WidgetSettingUpdate
  | WidgetSettingUpdateSuccess
  | WidgetSettingUpdateFail
  | AvailableWidgetsLoad
  | AvailableWidgetsLoadSuccess
  | AvailableWidgetsLoadFail;
